import classnames from "classnames"
import React from "react"
import { Row, Col } from "react-bootstrap"
import Form from "react-bootstrap/Form"
import Modal from "react-bootstrap/Modal"
import Button from "../Layout/Button"
import styles from "./GalleryContactModal.module.css"
import ReCAPTCHA from "react-google-recaptcha"

export const GalleryContactModal = ({
  modal,
  handleClose,
  onSubmit,
  galleryDetails,
  setForm,
  form,
  error,
  errorMessage,
  success,
  onReCAPTCHAChange,
  recaptchaRef,
}) => {
  const innerRef = React.createRef()

  React.useEffect(() => {
    setTimeout(() => {
      innerRef.current?.focus()
    }, 1)
  }, [modal])

  const contactTitle = `Contact ${
    (galleryDetails && galleryDetails.name) || "Us"
  }`

  return (
    <Modal
      show={modal}
      onHide={handleClose}
      className={styles["modal-content"]}>
      <Modal.Header className={styles["modal"]} closeButton />
      <Modal.Body closeButton>
        {success ? (
          <Row>
            <div className="mx-4 px-2 mb-4 w-100 text-center alert">
              Your message has been sent. We’ll get back to you soon.
              <br />
              Thank you!
            </div>
          </Row>
        ) : (
          <>
            <div className="mx-4 px-2">
              <h3 className="text-black mb-3 fs-24px">{contactTitle}</h3>
            </div>
            <div>
              <Form className="mx-4 px-2" onSubmit={onSubmit}>
                <Form.Group controlId="email" className="mb-2">
                  <Form.Label className="text-capitalize fs-14px text-black">
                    Email*
                  </Form.Label>
                  <Form.Control
                    className={styles.inputFontSize}
                    type="email"
                    onChange={(event) => {
                      setForm({ ...form, email: event.target.value })
                    }}
                    value={form.email}
                    autoFocus
                    ref={innerRef}
                  />
                </Form.Group>

                <Row>
                  <Form.Group
                    as={Col}
                    controlId="firstName"
                    className="mb-2 pr-2 pl-3">
                    <Form.Label className="text-capitalize text-black fs-14px">
                      First Name*
                    </Form.Label>
                    <Form.Control
                      className="input-font-size"
                      type="name"
                      onChange={(event) => {
                        setForm({ ...form, firstname: event.target.value })
                      }}
                      value={form.firstname}
                    />
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    controlId="lastName"
                    className="mb-2 pl-2 pr-3">
                    <Form.Label className="text-capitalize text-black fs-14px">
                      Last Name*
                    </Form.Label>
                    <Form.Control
                      className="input-font-size"
                      type="name"
                      onChange={(event) => {
                        setForm({ ...form, lastname: event.target.value })
                      }}
                      value={form.lastname}
                    />
                  </Form.Group>
                </Row>

                <Form.Group controlId="message" className="mb-2">
                  <Form.Label className="text-capitalize fs-14px text-black">
                    Message*
                  </Form.Label>
                  <Form.Control
                    className={styles.inputFontSize}
                    as="textarea"
                    rows="3"
                    onChange={(event) => {
                      setForm({ ...form, body: event.target.value })
                    }}
                    value={form.body}
                  />
                </Form.Group>

                <Form.Group controlId="phone" className="mb-2">
                  <Form.Label className="text-capitalize fs-14px text-black">
                    Phone Number{" "}
                    <span className="color-gray-super-light fs-12px">
                      {"(Numbers Only)"}
                    </span>
                  </Form.Label>
                  <Form.Control
                    className={styles.inputFontSize}
                    type="number"
                    onChange={(event) => {
                      setForm({ ...form, phone: event.target.value })
                    }}
                    value={form.phone}
                  />
                </Form.Group>

                <ReCAPTCHA
                  ref={recaptchaRef}
                  size="invisible"
                  sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                  onChange={onReCAPTCHAChange}
                />

                {error && (
                  <div className="w-100 alert alert-danger">
                    {errorMessage.map((error) => (
                      <div>
                        {error}
                        <br />
                      </div>
                    ))}
                  </div>
                )}

                <hr />
                <Button type="submit">SUBMIT</Button>
              </Form>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
